import { GlobalResponseObject } from '../../../common';
import { ExcelImportModel } from './excel-import.model';

export class ExcelImportResponse extends GlobalResponseObject {
    data?: ExcelImportModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ExcelImportModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}